import React, { useState } from "react";
import Cropper from "react-easy-crop";

import { Container, ButtonContainer, CropArea, InnerContainer } from "./styles";
import Button from "components/button";
import getCroppedImg from "utils/cropImage";
import colours from "assets/colours";

const ImageCropper = ({
  imageB64,
  open,
  closeHandler,
  cropHandler,
  imageType,
}) => {
  const [state, setState] = useState({
    image: imageB64,
    crop: { x: 0, y: 0 },
    zoom: 1,
    aspect: 4 / 4,
    croppedAreaPixels: null,
    cropShape: "round",
  });

  const onCropChange = (crop) => {
    setState({ ...state, crop });
  };

  const onCropComplete = (croppedArea, croppedAreaPixels) => {
    setState({ ...state, croppedAreaPixels });
  };

  const onZoomChange = (zoom) => {
    setState({ ...state, zoom });
  };

  const completeCrop = async () => {
    try {
      const croppedImage = await getCroppedImg(
        imageB64,
        state.croppedAreaPixels,
        imageType
      );
      cropHandler(croppedImage);
    } catch (err) {
      console.error(err);
    }
  };

  return (
    open && (
      <Container>
        <InnerContainer>
          <CropArea>
            <Cropper
              image={imageB64}
              aspect={state.aspect}
              zoom={state.zoom}
              crop={state.crop}
              cropShape={state.cropShape}
              onCropChange={onCropChange}
              onCropComplete={onCropComplete}
              onZoomChange={onZoomChange}
              style={{
                cropAreaStyle: {
                  width: 400,
                  height: 400,
                  color: colours.grey3,
                  opacity: 0.8,
                },
              }}
            />
          </CropArea>
          <ButtonContainer>
            <Button onClick={closeHandler} variant="zltoDarkBlue">
              Cancel
            </Button>
            <Button onClick={completeCrop}>Done</Button>
          </ButtonContainer>
        </InnerContainer>
      </Container>
    )
  );
};

export default ImageCropper;
